import React from "react";
import styled from "styled-components";

function FlexSpaceCenter(props) {
    const FlexSpaceCenter = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    `;
  return (
    <FlexSpaceCenter>
        {props.children}
    </FlexSpaceCenter>
  );
}

export default FlexSpaceCenter;
